var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Logs"}},[_c('el-card',[_c('div',{staticClass:"logs",domProps:{"innerHTML":_vm._s(_vm.logs)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }